export default __webpack_public_path__ + "static/media/v7.6f1098d1.jpg";